export default __webpack_public_path__ + "static/logo-d9d947dfe09d0e115ed087111404b2db.png";